var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Room",
            "fields": [],
            "messages": [
                {
                    "name": "WebNormalInto",
                    "fields": [],
                    "options": {
                        "java_package": "com.asiainno.uplive.proto",
                        "objc_class_prefix": "RoomWebNormalInto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "roomId",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "WebType",
                                    "name": "wType",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "checkLifted",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "agreePayFlag",
                                    "id": 4
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "liveMsg",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "uid",
                                    "id": 2
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "liveTimes",
                                    "id": 3
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "peoples",
                                    "id": 4
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "acceptLanguage",
                                    "id": 5
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "wsIp",
                                    "id": 6
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "wsPort",
                                    "id": 7
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "wsPath",
                                    "id": 8
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "time",
                                    "id": 9
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "nonce",
                                    "id": 10
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "sec",
                                    "id": 11
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "userInfo",
                                    "id": 12
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "termType",
                                    "id": 13
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "sid",
                                    "id": 14
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "checkLiftedR",
                                    "id": 15
                                },
                                {
                                    "rule": "repeated",
                                    "type": "string",
                                    "name": "userLabels",
                                    "id": 16
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "labelHighest",
                                    "id": 17
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "policyMsg",
                                    "id": 18
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "dressingFlag",
                                    "id": 19
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "fee",
                                    "id": 20
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "privateLiveFlag",
                                    "id": 21
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "diamond",
                                    "id": 22
                                },
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "keepTime",
                                    "id": 23
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "voiceFlag",
                                    "id": 24
                                },
                                {
                                    "rule": "optional",
                                    "type": "bool",
                                    "name": "landscapeFlag",
                                    "id": 25
                                },
                                {
                                    "rule": "optional",
                                    "type": "LiveModel",
                                    "name": "liveModel",
                                    "id": 26
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "multiliving",
                                    "id": 27
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "gameTag",
                                    "id": 28
                                },
                                {
                                    "rule": "optional",
                                    "type": "string",
                                    "name": "multirateUrl",
                                    "id": 29
                                }
                            ]
                        }
                    ],
                    "enums": [
                        {
                            "name": "WebType",
                            "values": [
                                {
                                    "name": "WEB",
                                    "id": 0
                                },
                                {
                                    "name": "WAP",
                                    "id": 1
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "LiveModel",
            "values": [
                {
                    "name": "LIVE",
                    "id": 0
                },
                {
                    "name": "MAKEFRIEND",
                    "id": 1
                },
                {
                    "name": "GAMELIVE",
                    "id": 2
                }
            ]
        }
    ]
}).build();
export default _root;


// WEBPACK FOOTER //
// ./js/component/webchat/into.pb.js